"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
var ErrorCode;
(function (ErrorCode) {
    // Authentication (Firebase)
    ErrorCode["AuthWrongPassword"] = "auth/wrong-password";
    ErrorCode["AuthPermissionDenied"] = "auth/permission-denied";
    ErrorCode["AuthUserNotFound"] = "auth/user-not-found";
    ErrorCode["AuthUserDisabled"] = "auth/user-disabled";
    ErrorCode["AuthInvalidEmail"] = "auth/invalid-email";
    ErrorCode["AuthTooManyAttempts"] = "auth/too-many-requests";
    ErrorCode["AuthEmailAlreadyInUse"] = "auth/email-already-in-use";
    ErrorCode["AuthAccountExistWithAnotherProvider"] = "auth/account-exists-with-different-credential";
    ErrorCode["AuthOperationNotAllowed"] = "auth/operation-not-allowed";
    ErrorCode["AuthInvalidCredentials"] = "auth/invalid-credential";
    ErrorCode["AuthWeakPassword"] = "auth/weak-password";
    ErrorCode["AuthInvalidActionCode"] = "auth/invalid-action-code";
    ErrorCode["AuthExpiredActionCode"] = "auth/expired-action-code";
    ErrorCode["AuthNetworkRequestFailed"] = "auth/network-request-failed";
    ErrorCode["AuthRecentLoginRequiredException"] = "auth/requires-recent-login";
    // User/Company email verification
    ErrorCode["UserEmailVerificationTokenExpired"] = "760d951d-8b3d-4d7b-b77f-403102c62866";
    ErrorCode["UserEmailVerificationTokenNotFound"] = "507929f0-6885-4d5f-a427-1a286e09b54e";
    ErrorCode["UserEmailAlreadyVerified"] = "690370bb-6bf7-4cb9-abee-bb24a155cedc";
    ErrorCode["CompanyEmailAlreadyInUse"] = "dc9afdba-61c1-4763-a81c-741c71e62a11";
    /** Custom (client-side) */
    ErrorCode["AuthMissingSuperadminClaim"] = "authMissingSuperadminClaim";
    /** Custom (client-side) */
    ErrorCode["AuthUserNotAdmin"] = "authUserNotAdmin";
    // General
    /** Custom (client-side) */
    ErrorCode["RequestCancelledFromClient"] = "requestCancelledFromClient";
    ErrorCode["UserIsNotTenantUserForOutlet"] = "04c977d9-9b33-45d3-8b1c-845da96e4e61";
    ErrorCode["ClientNotAllowed"] = "a70e805f-1cf5-4fbb-a2ca-b692460ad538";
    ErrorCode["CheckIsClosed"] = "3e455269-d559-4c05-993c-13a60eb8cce3";
    ErrorCode["InvalidCheckId"] = "db7ef55c-25e8-4fc7-b964-3fff47933496";
    ErrorCode["TenantUserAlreadyExists"] = "e09a749d-6fd2-4594-9b41-0f96c2a543fb";
    ErrorCode["PinAlreadyInUse"] = "455a8277-8194-49dc-b2bd-ea8af1cdbdd6";
    /** Custom (client-side) */
    ErrorCode["ProductOutOfStock"] = "productOutOfStock";
    // Companies
    ErrorCode["CompanyNameAlreadyExists"] = "8d2fc55b-012e-4d62-aff4-ac01f2eda154";
    ErrorCode["CompanyMemberEmailAlreadyExists"] = "fbe42816-708b-4263-9c6f-d3128237d1d5";
    ErrorCode["CompanyMemberAccountAlreadyExists"] = "ada54105-7500-410b-81b6-17ec6ec75d27";
    ErrorCode["CompanyInvitationTokenNotFound"] = "bf58fc54-1178-4b57-b8a3-0c92b3dcfa5e";
    ErrorCode["CompanyInvitationTokenExpired"] = "e7bda5bc-2b49-4240-a01d-d8a31c76a834";
    // Accounting
    ErrorCode["AccountNumberMissingError"] = "01a8a48a-45f1-4297-bd82-6f26cfb16f19";
    // License
    ErrorCode["BusinessNumberMismatch"] = "e3c8b7b2-db4c-4423-96c0-04516f497060";
    // Integration
    ErrorCode["OrderNotFoundError"] = "23116b2c-307a-4a2e-9521-76643eb2788c";
    ErrorCode["VoucherNotFoundError"] = "e6cd97ea-0708-4d9e-b443-e4ec3976d3f8";
    ErrorCode["FortnoxAccChangeNotAllowed"] = "610f4800-73c9-4cca-818e-92584452f7c1";
    ErrorCode["FortnoxAuthenticationFailed"] = "3e9a7704-818a-4c61-beee-cf43fb258257";
    ErrorCode["PersonalkollenEmployeesFailed"] = "e38ff3a3-eca0-471d-aa0b-f54b9548b5fa";
    ErrorCode["PersonalkollenAuthenticationFailed"] = "efad9aa4-8180-4176-b032-2b89a0493737";
    ErrorCode["PersonalKollenInvalidCashRegisterKey"] = "1f99c1b4-9536-4102-a764-3b708fb24d64";
    ErrorCode["PlandayAuthenticationFailed"] = "ea6e0818-1d73-4a81-841f-04da640a6871";
    ErrorCode["IntegrationAccountCategoryDuplicate"] = "81c61746-ea13-4663-9ef8-b78d8437b467";
    ErrorCode["HistoricalDataSyncMaximumDays"] = "931f21ac-259f-44e6-bfc8-b1fe89c33d08";
    // Licenses
    ErrorCode["InvalidMacAddress"] = "47c7bedf-443c-4034-ba27-c29934dca994";
    // Product Groups
    ErrorCode["ProductGroupAlreadyAvailable"] = "931c9d99-43c0-4e04-a32f-172504de1a1e";
    ErrorCode["InvalidStarCloudFirmwareVersion"] = "8783fe3b-2c6f-4416-8217-f3046eae9b18";
    ErrorCode["CashRegisterNotUnique"] = "5bd9afa1-d747-461c-81ab-818051a70936";
    // Discounts
    ErrorCode["DiscountCodeAlreadyExist"] = "54009eb1-aa31-4d5d-8d68-f9c5af116d90";
    ErrorCode["DiscountInvalidOutlet"] = "ec0d450b-aa70-4021-92d1-7f7643833235";
    ErrorCode["DiscountInvalidProduct"] = "e0abab9f-d014-4bbf-bfde-4e399bae4cd5";
    ErrorCode["DiscountInvalidProductGroup"] = "5791c60d-1d97-479f-ba69-d2f3727609e5";
    ErrorCode["DiscountInvalidCustomerDetails"] = "0cf12113-96ef-4b4a-9d06-c8b493507154";
    ErrorCode["DiscountInvalidInputOrderFormat"] = "f8b71704-6c00-411e-bdb4-ba2efba6211d";
    ErrorCode["DiscountAlreadyUsedForCustomer"] = "45bfe472-7ffc-4e61-88f0-310832af2748";
    ErrorCode["DiscountPeriodNotStarted"] = "7f5fbcb9-9ad1-4530-95b6-02f88fc52388";
    ErrorCode["DiscountPeriodEnded"] = "e0b230f8-534b-4538-b6d2-5c3c2de968a8";
    ErrorCode["DiscountInvalidTimePeriod"] = "c0da8f96-1c98-4f64-8e63-d5e5b15e19ee";
    ErrorCode["DiscountInvalidDayOfWeek"] = "0d561524-2261-41cd-a342-0772d6bfeff4";
    ErrorCode["DiscountInvalidOrderFormat"] = "7a5c42ae-16dc-4f3b-8052-436f7e0b41a5";
    ErrorCode["DiscountNeedToBeLoggedIn"] = "90c621dd-6df6-4179-9b2d-26cd1758c22d";
    ErrorCode["DiscountNotValid"] = "e614836a-4ee0-49e6-add4-8c4ba3e86260";
    ErrorCode["DiscountNotAllowedCustomDiscounts"] = "833fe1bf-0976-4706-b898-4aed3068f765";
    ErrorCode["AlreadyClaimed"] = "04fc7881-6513-4c03-9329-b9b746372085";
    ErrorCode["AlreadyPrinted"] = "5512e329-7ee3-42ee-80c7-c3b852a0f6bb";
    ErrorCode["NoPermissionForAction"] = "9274b250-5698-4e4f-95c9-c56adf7933af";
    ErrorCode["InvalidApiKey"] = "8f787dea-2a9f-48c6-b839-b0c9eca3ee15";
    // Printer hardware
    ErrorCode["SerialNumberAlreadyInOutlet"] = "fb6052d2-f906-4cc0-934d-c95890c0f473";
    ErrorCode["MacAddressAlreadyInOutlet"] = "9e786e6a-7732-4dc1-80f1-f126b7d811fc";
    // Receipts
    ErrorCode["ReceiptCopyAlreadyPrinted"] = "bdf230ef-f133-46c7-9f78-0e2d4a1dc465";
    ErrorCode["ReceiptAlreadyPrinted"] = "5815b9a3-753d-4ff8-a5f9-08aba82817bc";
    // Check items
    ErrorCode["MoveTooManyCheckItems"] = "bbb5d626-92e4-4580-beb5-4a7f28b891ff";
    ErrorCode["CheckItemsInvalidQuantity"] = "c189a099-255c-4808-aa43-dc523f748019";
    ErrorCode["CheckItemsAreLocked"] = "81040027-aa5d-40a4-b0d8-2b687ce9497a";
    ErrorCode["CheckItemsIdAreInvalid"] = "540f4719-1f9e-4172-b1db-5a18168042e7";
    ErrorCode["CheckItemDuplicate"] = "69492c44-214c-4c5a-b402-6254dd26e60a";
    ErrorCode["CheckItemWithIdAlreadyExists"] = "4038fc2d-779b-49b9-8cab-ca0d3e3abf47";
    ErrorCode["CheckItemInvalidPriceForCheck"] = "0352e317-3643-41e3-9658-16f9197a2444";
    ErrorCode["CheckItemIsAlreadyProduct"] = "f901e3fe-8bf4-4dfd-a125-0580d347e584";
    ErrorCode["CheckItemsAreInCompleted"] = "b558563b-8e0b-4d2e-b3c1-f189a9aa56f8";
    ErrorCode["CannotSplitMultiProducts"] = "48068345-8caa-4149-ad8b-0d9c28bb1b5a";
    ErrorCode["CannotSplitUnstoppedTimeBasedProducts"] = "a3d4756d-5096-4d43-96ca-f2dda6728534";
    ErrorCode["CannotSplitBeyondZero"] = "f3b39ac7-df82-4533-9213-373c1d99a589";
    // Check
    ErrorCode["InvalidCheck"] = "3b2e8ca6-4f28-42c5-bb37-6db2f9a38cca";
    /** Custom (client-side) */
    ErrorCode["CheckMergeFailed"] = "checkMergeFailed";
    /** Custom (client-side) */
    ErrorCode["CreateTableCheckNoTableSelected"] = "createTableCheckNoTableSelected";
    /** Expired because of pay-n-go merge-back */
    ErrorCode["CheckIsExpired"] = "fddd3881-9cd1-4eda-9968-692e92867988";
    ErrorCode["CannotExtractTimeBasedProducts"] = "4db21543-9a1a-41c5-a490-81ebf9dc1621";
    ErrorCode["CheckNotFullyTicketedOrForwarded"] = "899687d6-2b26-4147-af34-a344b36960e9";
    // Payment
    ErrorCode["CheckHasPayment"] = "8c46f9af-75d4-4e5b-8f0b-3e8bf69eb567";
    ErrorCode["TotalAmountCannotBeZero"] = "1ecf6cc2-55a5-4c1b-8e2f-8fb9540712f9";
    ErrorCode["CheckInvalidTaxes"] = "b389f7d2-204b-456a-8919-75408a75f027";
    ErrorCode["AmountToPayCannotBeZero"] = "7ad82479-9383-41a2-8b5d-7a48ac1bfc37";
    ErrorCode["CheckItemsAreNotLocked"] = "0cff8de1-3535-4b5f-9594-3caae1465deb";
    ErrorCode["CheckItemsNotTicketed"] = "c342ab24-d0b6-4781-b30c-720f96be9a90";
    ErrorCode["AmountToPayIsTooHigh"] = "c58bfdc9-9daf-4d4a-aaf6-301fb371254d";
    ErrorCode["CashNotConfigured"] = "0723dc47-b901-43d5-9582-562d4974c2e1";
    ErrorCode["PosChangeSumNotSetForVoucherBasis"] = "aadb793e-e686-43b4-96e0-23ea7aad91d9";
    ErrorCode["CheckItemsAlreadyPaid"] = "557ecd32-7ea5-46fa-9067-48d508f1b175";
    ErrorCode["PaymentMethodNotAllowed"] = "5b6c55c2-3d17-49b2-8f4c-bf9cca053dee";
    ErrorCode["PaymentTerminalRequired"] = "e83a7e73-6a64-430e-8101-633c70304e67";
    ErrorCode["PaymentTerminalBusy"] = "40a8adb3-06ac-46cb-9416-ddd7983afbd0";
    ErrorCode["InvalidPaymentId"] = "b63a3de9-469d-49a6-afaa-fc573872ce0a";
    ErrorCode["AuthorizeDataNotValid"] = "79ff86ad-99af-48bd-bf9e-aad069ef4667";
    ErrorCode["AuthorizeErrorUnknownReason"] = "bf54f842-44fc-40c2-b606-f3ca7d304a6a";
    ErrorCode["AuthorizeCheckoutCaptured"] = "5bcb78b7-844b-4f33-94f2-b9e7dfae2368";
    ErrorCode["AuthorizeCheckoutAuthorized"] = "38604f42-4051-497e-a297-c654f8695cf2";
    ErrorCode["AuthorizeCaptureFailure"] = "24b4bf90-5499-469d-8606-0047e262ebcb";
    ErrorCode["AuthorizeCancelOrRefund"] = "5dfeabe5-b0d3-4add-830b-1d5ca9613c03";
    ErrorCode["ActionErrorUnknownReason"] = "843658a0-8f66-485c-b0d3-cca0856d98be";
    ErrorCode["ActionInvalidData"] = "a743b8ff-3ca7-4a11-83b3-ce10f01fa7a8";
    ErrorCode["ActionCaptureFailure"] = "52c9671f-6def-4dbd-8355-6b468a63cc3a";
    ErrorCode["ActionCancelOrRefund"] = "abdcdfe6-0fa5-47aa-8d92-6269c573c2d2";
    ErrorCode["PaymentCheckoutAlreadyInProgress"] = "9e915d0a-f873-4da5-953b-c386f9be25ae";
    ErrorCode["PaymentCheckoutCreated"] = "f1a704a1-6ae2-4b85-afa0-62e6e107c43e";
    ErrorCode["CheckoutPriceChanged"] = "d46dc631-4a6b-4a48-8206-d01ef640179f";
    ErrorCode["CheckPriceChanged"] = "fd1243dd-55b7-4d80-972a-b6d7ada545f4";
    ErrorCode["DeleteCheckoutWhenPaymentStarted"] = "9a3b3cf6-da61-4bae-817c-7965df7c4a48";
    ErrorCode["PaymentDetailsNotSupported"] = "905";
    ErrorCode["AppNotFound"] = "appNotFound";
    /** Custom (client-side) */
    ErrorCode["UnavailableDevice"] = "unavailableDevice";
    ErrorCode["InvoicePaymentsNotAllowed"] = "4b42283d-d4ae-4a5d-bbb7-8a9ddd5a6f5a";
    ErrorCode["InvoicePaymentsNotAllowedHolyGreens"] = "45704ca4-620e-4d28-bb9e-a0d7751dd632";
    // Penguin Lockers Payment Errors
    ErrorCode["CheckoutPenguinInvalidStation"] = "812fefc2-1168-4ab5-8279-f4db1bad8f9e";
    ErrorCode["CheckoutPenguinInvalidTimeSlot"] = "de82fbda-e67f-427f-ac37-bf81d4c484fe";
    ErrorCode["CheckoutPenguinNotEnoughLockers"] = "bb7e464a-a1f0-4534-8b23-023e89946be3";
    ErrorCode["CheckoutPenguinTooManyItems"] = "713b681f-b84a-4141-bd93-a6d782f1ee9a";
    ErrorCode["CheckoutPenguinProductInvalidUnits"] = "ec682fa3-d91d-4be9-9404-94cf762b48cb";
    ErrorCode["CheckoutPenguinUnauthorized"] = "1158b7cb-64f5-423c-abba-29ee2e2c3010";
    /** Custom (client-side) order format not confirmed with forced order enabled */
    ErrorCode["OrderFormatNotConfirmed"] = "orderFormatNotConfirmed";
    // Integrations
    ErrorCode["InvalidIntegrationInfoGiven"] = "07af3b89-f744-4ded-a596-52c58cb6603a";
    ErrorCode["IntegrationInvalid"] = "1bd97685-b3cb-45e3-b05e-8dd872f96ebf";
    ErrorCode["IntegrationRequestFailed"] = "0672b298-29b0-46da-ad12-8336725a3954";
    ErrorCode["IntegrationMissingService"] = "1da5bf7c-3120-44e2-9299-5145be000d9d";
    ErrorCode["OnlyOneGiftCardTypeAllowed"] = "625ec56c-6973-4f81-b6ed-16aeb3d02a74";
    ErrorCode["IntegrationSettingInvalid"] = "a87b3aba-2030-4f96-b904-7f5110d003ff";
    ErrorCode["CannotUseMultipleGiftCardIntegrations"] = "3eb593b8-1605-43ec-a144-b98de699b7db";
    ErrorCode["RequiredAccountNumbersNotFoundForAdyen"] = "aad1dadd-f6c5-401c-9ae1-cdf0788dc952";
    ErrorCode["IntegrationNotFound"] = "c5a342a8-7587-4b95-b330-74184a05d6cc";
    ErrorCode["IntegrationInactive"] = "a4680cf0-d97d-4db2-bf98-3b8507494a11";
    // Printer
    /** Custom (client-side) Connection timed out */
    ErrorCode["PrinterTimeoutGeneral"] = "printerTimeoutGeneral";
    /** Custom (client-side) Connection timed out while connecting */
    ErrorCode["PrinterTimeoutConnecting"] = "printerTimeoutConnecting";
    /** Custom (client-side) Printer cover is open */
    ErrorCode["PrinterCoverOpen"] = "printerCoverOpen";
    /** Custom (client-side) Printer paper empty */
    ErrorCode["PrinterPaperEmpty"] = "printerPaperEmpty";
    /** Custom (client-side) Printer has any device error */
    ErrorCode["PrinterAnyDeviceError"] = "printerAnyDeviceError";
    /** Custom (client-side) Printer is in use */
    ErrorCode["PrinterInUse"] = "printerInUse";
    /** Custom (client-side) Network was lost during printing */
    ErrorCode["PrintingNetworkLost"] = "printingNetworkLost";
    /** Custom (client-side) Connection timed out because the app was suspended */
    ErrorCode["PrinterTimeoutSuspended"] = "printerTimeoutSuspended";
    /** Custom (client-side) Printing background service expired (iOS only) */
    ErrorCode["PrintingBackgroundServiceExpired"] = "printingBackgroundServiceExpired";
    // Checkouts
    ErrorCode["PaymentAcceptInvalidStatus"] = "34e104fe-ac3a-455d-a632-121f545e4586";
    ErrorCode["PaymentAcceptOutOfStock"] = "10c146fe-c0c3-433d-b3de-3a6d79b35669";
    ErrorCode["RequestedOrderFormatNotSupportedByOutlet"] = "53090974-7e39-40fd-ae1c-150a2678ee60";
    ErrorCode["RequestedOutletIsNotOpen"] = "de0da2ec-e022-4b6f-9c9e-259cb1c092b2";
    ErrorCode["ItemsNotValidNotAvailable"] = "31a89824-04dc-4d64-987f-95eabb6dced9";
    ErrorCode["ItemsNotValidNotExists"] = "64e93a9c-155f-4462-9bec-94c67dec0391";
    ErrorCode["ItemsNotValidNotAllowedQuantity"] = "729e0f0c-ec15-407c-97f1-bc53b6958509";
    ErrorCode["DeliveryToAddressNotSupported"] = "6bcd96fc-6b76-4456-a759-e2b03ec26e6d";
    ErrorCode["ServiceTimeInThePast"] = "7f9be57f-82ba-481c-a206-5ae43bd3f223";
    ErrorCode["TableOrderRequiresServiceTimeAsap"] = "069e3724-c39d-4eec-b4de-af6db83bbd5f";
    ErrorCode["RequestTimeInvalid"] = "100011";
    ErrorCode["RequestItemsNotDefined"] = "b557d598-54b3-426d-950a-676608e1c160";
    ErrorCode["RequestItemsNotValid"] = "74bd59c6-a860-4001-8ae1-8c34bd200224";
    ErrorCode["ItemsNotValidBlocked"] = "635dfe6b-772f-4c9e-8ab2-afbbd77be590";
    ErrorCode["RequestDataNotValid"] = "41fcedd1-dfef-4d0d-a5b3-2e28da7dfc9a";
    ErrorCode["DeliveryInfoNotValid"] = "100032";
    ErrorCode["PaymentActionPaymentNotFound"] = "39611c66-0a9d-44cc-8618-9e10f80f8a7b";
    ErrorCode["PaymentAuthorizeNoItems"] = "44175a10-842c-4c34-862b-406a71a941a3";
    ErrorCode["PaymentAuthorizeInvalidCustomer"] = "8c55f102-dc3f-42b7-bac8-49becf505322";
    ErrorCode["PaymentAuthorizeInvalidDelivery"] = "e1beeb7e-3254-4585-81e7-81861b8ec5eb";
    ErrorCode["PaymentActionAuthorizeFailure"] = "3acf2a53-0431-4598-aa41-c4c5d369f938";
    ErrorCode["PaymentGetMethodsProviderError"] = "b5e97f60-9545-41f1-b1db-b3b242247f4a";
    ErrorCode["PaymentNotAllowedForProvidedCompanyAccount"] = "4b627777-3a6a-4451-a8dc-db6155a88d9c";
    ErrorCode["CheckoutDeliveryFeeNotFound"] = "0e313923-c465-4bba-af5c-a28b041b8ab8";
    /** Custom (client-side) Checkout selected order time is not available */
    ErrorCode["CheckoutUnavailableOrderTime"] = "checkoutUnavailableOrderTime";
    // Print voucher
    ErrorCode["EmptyVoucher"] = "f7953a81-f2dc-4f2a-8c48-4e24d4a269ff";
    // Courses
    ErrorCode["NoItemsAvailableInCourseToForward"] = "7a290574-a04c-4538-abbc-738e38cbe2de";
    ErrorCode["CourseNotFound"] = "872f0ad9-d96c-4a1e-9384-94b97f70aae5";
    ErrorCode["IncompatibleCoursePositionsBetweenChecks"] = "6ae451f5-9e7a-41ec-8469-7fb38ec5427d";
    /** Custom (client-side) */
    ErrorCode["IncompatibleCheckMergeWithForwardedCourses"] = "incompatibleCheckMergeWithForwardedCourses";
    ErrorCode["IncompatibleCheckItemMoveWithForwardedCourses"] = "incompatibleCheckItemMoveWithForwardedCourses";
    // Add Tips
    ErrorCode["CantAddToZReportedOrder"] = "05e81789-f56c-4005-abbe-117af202f95c";
    /**
     * @deprecated Use IntegrationInactive instead - this error code is common for all integrations
     */
    ErrorCode["IntegrationInactiveCannotAddTip"] = "a4680cf0-d97d-4db2-bf98-3b8507494a11";
    ErrorCode["CannotAddNegativeTip"] = "60ca6e2f-4250-4fb6-a367-3c9a20ea04fb";
    ErrorCode["CannotAddZeroTipAsFirstTip"] = "601db984-9362-4e9f-9e6a-bfc0f5a7d334";
    ErrorCode["CannotAddTipOnPaymentMethod"] = "475c54dc-2455-4334-865f-b0fdbfa8d897";
    // Mews
    /**
     * @deprecated Use IntegrationNotFound instead - this error code is common for all integrations
     */
    ErrorCode["MewsIntegrationNotFoundOrInactive"] = "c5a342a8-7587-4b95-b330-74184a05d6cc";
    ErrorCode["MewsCustomerNotCheckedIn"] = "0157a289-e7b6-474e-b79c-d1b5865a5330";
    ErrorCode["MewsFullPaymentRequired"] = "16ea7763-1014-412f-aaf3-0248df337435";
    ErrorCode["MewsTaxRateMissing"] = "95783c39-edc7-4363-a806-95f7db765aca";
    ErrorCode["VoucherBasisDraftExist"] = "11e0571d-235f-4155-9295-d9e54efd0a24";
    /** Custom (client-side) */
    ErrorCode["MissingMewsIntegration"] = "missingMewsIntegration";
    // Collection Tickets
    ErrorCode["CantCreateCollectionTicket"] = "b3bfe1f1-3e5a-4cc6-94ed-4aa1474f755b";
    /** Custom (client-side) */
    ErrorCode["CantAddTimeBasedProducts"] = "cantAddTimeBasedProducts";
    // Gift Cards
    ErrorCode["GiftCardPaymentNotSupported"] = "6066bfb1-fbec-43eb-b5ee-970697b0547c";
    ErrorCode["GiftCardPaymentNoValidItems"] = "e5c0b923-4a56-46bb-bd41-7e0906369a35";
    ErrorCode["GiftCardCannotBeRefunded"] = "2642f471-146f-45a7-ba22-8b7bf794d64a";
    ErrorCode["GiftCardIdInUse"] = "8b58c4d7-5dc0-40f2-b1c5-786e26b02642";
    ErrorCode["InvalidGiftCardId"] = "8d7b780c-49b1-4415-b1bd-22b15282a1dc";
    ErrorCode["GiftCardIsExpired"] = "b23ac2a9-fa9b-4935-8ca0-025f08f5a67a";
    ErrorCode["GiftCardIsPublished"] = "c21ee636-ca09-4dab-a1e1-593bcce834f6";
    ErrorCode["GiftCardUsageAmountInvalid"] = "e8f8f9df-b586-4459-b0f0-c099a0313b69";
    ErrorCode["GiftCardBalanceInvalid"] = "fabe8c03-040e-46c6-9a5f-e16efe64e04f";
    ErrorCode["GiftCardCurrencyMismatch"] = "1983c61f-91df-43ba-9c3a-f6e3a24cdef4";
    ErrorCode["GiftCardBalanceInsufficient"] = "45ef6754-fe6f-4e00-a118-343849fcedd9";
    ErrorCode["InvalidTransaction"] = "8236b677-9d53-4dfe-89e4-4962fcc1ca2e";
    ErrorCode["InvalidOrderId"] = "fc053351-a2b0-48a2-b35f-b93e7ca226e2";
    ErrorCode["InvalidCSVFormat"] = "a5c64e52-acec-4083-90e4-eb2c0f03070d";
    ErrorCode["SellGiftCardsDisabled"] = "489bf449-f453-4c3f-bcda-4f29932e9440";
    ErrorCode["GiftCardPaymentFail"] = "ce923228-5548-45e8-94ca-7182870a23e2";
    ErrorCode["GiftCardRefundFail"] = "3fdc1ec3-482f-4dbf-9010-d0bc393dd565";
    ErrorCode["OutletIdIsNeeded"] = "b064fb6f-ae99-4ae7-966a-7290aeb998e1";
    /** Custom (client-side) */
    ErrorCode["RequestCardDetailsNoPINSet"] = "requestCardDetailsNoPINSet";
    // Guest Count
    ErrorCode["CreateTableCheckGuestCountMissing"] = "2c92b956-a8b8-41f3-869c-ec1fbc5a2db4";
    /** Custom (client-side) */
    ErrorCode["CreateTableCheckNoGuestCountSet"] = "createTableCheckNoGuestCountSet";
    // Refund
    ErrorCode["RefundQuantityInvalid"] = "479982fb-2190-4dc7-b4fa-e64f7f17a8ce";
    // Star Printer discovery
    ErrorCode["NoPrintersFound"] = "c46d7f41-2ed3-4d73-8cb9-ad9ba2a68be0";
    // Outlet
    ErrorCode["OutletNameAlreadyExist"] = "c6a2b5b4-9f67-4388-9f56-d53dc89577c9";
    ErrorCode["UrlSlugAlreadyExist"] = "fbe7950d-a4e9-45d2-bc30-6ea030588328";
    ErrorCode["OutletInvalidDeliveryAreaLocations"] = "5590c93c-9832-4717-acf4-b04c551b5578";
    // Outlet Client
    ErrorCode["PosClientBarHasOpenChecks"] = "b56179ea-8806-451f-95de-b0b7ed4f9f64";
    // Metadata
    ErrorCode["MetadataIsNull"] = "7af42779-13c8-4942-a7ea-f63be322a2cb";
    ErrorCode["MetadataIsInvalid"] = "d66e443a-c177-4a32-a48a-e20a3380a112";
    ErrorCode["MetadataJsonTooBig"] = "eec58588-76f6-4d3e-99eb-bb663b5d4b0b";
    ErrorCode["MetadataJsonInvalidType"] = "f876014d-a2f8-47c0-87f5-33e04fd86da1";
    // Metadata Template
    ErrorCode["MetadataTemplateTypeAlreadyExistsForTenant"] = "ce03ba99-9604-446d-96de-6d4a6c59e89c";
    ErrorCode["MetadataTemplateJsonTooBig"] = "a1884eb1-a146-4d99-a8f6-882f84e2a94c";
    ErrorCode["MetadataTemplateJsonInvalidType"] = "76b1689c-e37c-4910-8c2b-099090ba69dc";
    ErrorCode["MetadataTemplateJsonSchemaFailsValidation"] = "2d650391-d296-4527-9831-777910d95eea";
    ErrorCode["MetadataTemplateJsonSchemaFailsValidationOfDefaultSchema"] = "10c7bda1-28dd-4c71-aa5f-bce03bfb3495";
    // Upsell
    ErrorCode["UpsellProductIsOpenPrice"] = "0ec946ea-3b55-42de-a3d8-0d1e740b123b";
    ErrorCode["UpsellProductHasAddOnGroupWithMinimumAmount"] = "8e0d1b56-6885-49c8-80c7-9b9d62236221";
    // Terminal
    ErrorCode["TerminalAlreadyExists"] = "af5edfbe-9087-41ad-ae2c-b681fe404e54";
    ErrorCode["TerminalNotFoundInEnvironment"] = "b6329c24-c720-4d65-acc6-14a81680fff1";
    // Wallets
    ErrorCode["WalletExistForGuestUnderSameTenant"] = "4080b646-8a5d-4f7a-8190-c2939a7552f4";
    ErrorCode["WalletDeleteOrInvalid"] = "a46ead1b-df93-4812-b943-9abc65669c31";
    ErrorCode["WalletCannotSellMultipleForSameGuest"] = "7dd42a15-24f4-4112-ba39-400c75e87b08";
    ErrorCode["WalletInvalidDiscount"] = "97c8ba56-7805-4e85-bfaf-5c75aeab1044";
    /** Custom (client-side) */
    ErrorCode["CantActivateGuestNotLinkedWallet"] = "cantActivateGuestNotLinkedWallet";
    // Tickets
    ErrorCode["IncompletePayment"] = "a439907a-b47f-42fb-8d43-6c0263178b01";
    // Tables
    /** Custom (client-side) */
    ErrorCode["QRTableOrderingInvalidQR"] = "qrTableOrderingInvalidQRCode";
    /** Custom (client-side) */
    ErrorCode["QRTableOrderingOutletClosed"] = "qrTableOrderingOutletClosed";
    /** Custom (client-side) */
    ErrorCode["QRTableOrderingTableNotFound"] = "qrTableOrderingTableNotFound";
    /** Custom (client-side) */
    ErrorCode["QRTableOrderingTableUnavailable"] = "qrTableOrderingTableUnavailable";
    // Hangfire
    /** Custom (client-side) */
    ErrorCode["GenericUnexpectedHangfireError"] = "genericUnexpectedHangfireError";
    /** Custom (client-side) */
    ErrorCode["GenericExpectedHangfireError"] = "genericExpectedHangfireError";
    /** Custom (client-side) */
    ErrorCode["HangfireWorkerExpiredOrInvalid"] = "hangfireWorkerExpiredOrInvalid";
    // Omniboost
    /** Custom (client-side) */
    ErrorCode["MissingOmniboostPMSIntegration"] = "missingOmniboostPMSIntegration";
    // Como
    ErrorCode["ComoPendingVerification"] = "8608ad9d-2e3c-4cbf-9d45-271fe6835c5f";
    ErrorCode["ComoInvalidVerification"] = "98f598a5-d741-4baf-b716-c36462c9ebf3";
    ErrorCode["ComoMemberNotFound"] = "b7b80e03-c8d2-4644-b621-feef76362c38";
    ErrorCode["DoesNotHaveValidCheckItems"] = "b015a18d-b037-435f-a396-25a2f4b5954d";
    ErrorCode["ComoCouponNotValid"] = "ea2030c2-8e57-401e-b242-22494f931f8f";
    ErrorCode["ComoRewardCannotBeClaimedAtThisMoment"] = "d0807761-1f29-4909-9fcb-e02c9d3b3abd";
    ErrorCode["ComoViolationOfAssetConditionsWhenCheckMetadataUpdate"] = "6980d794-2e8a-4dde-997b-6b25cc0e6964";
    ErrorCode["ComoViolationOfAssetConditionsWhenCheckItemAdd"] = "d6e069e5-480d-490e-92ab-5977f1b17d5d";
    ErrorCode["ComoViolationOfAssetConditionsWhenCheckItemRemove"] = "a304c3dd-b4aa-43ab-ad6f-4d57021a0cb4";
    ErrorCode["ComoViolationOfAssetConditionsWhenCheckItemQuantityChange"] = "ae99ad29-1b83-4aaa-8dfb-b41f77f48875";
    ErrorCode["ComoViolationOfAssetConditionsWhenCheckItemUnitQuantityChange"] = "e359f43d-e876-4752-b776-143801a2d2ce";
    ErrorCode["ComoViolationOfAssetConditionsWhenCheckMerge"] = "46da21f8-2dd1-49ed-a7a9-1336cdb9511e";
    ErrorCode["ComoViolationOfAssetConditionsWhenCheckDiscount"] = "a6433e1b-890e-436a-a32b-b49e7355a7ca";
    ErrorCode["ComoViolationOfAssetConditionsWhenCheckItemPriceUpdate"] = "512f5b38-66d2-43bf-8372-ed20ad63166a";
    ErrorCode["ComoViolationOfAssetConditionsWhenCheckItemModificationsUpdate"] = "f0d82f35-de97-4de2-84b3-f9818d95156d";
    ErrorCode["ComoViolationOfAssetConditionsWhenCheckItemProductUpdate"] = "834337bd-4dbc-4aeb-94d7-ba34fe2c2a26";
    // Stammy
    /** Custom (client-side) */
    ErrorCode["StammyInsufficientBalance"] = "insufficientBalance";
    // API deprecations
    /** Custom (client-side) */
    ErrorCode["DeprecatedEndpointVersion"] = "deprecatedEndpointVersion";
    // Maitres
    ErrorCode["MaitresNoCheckOrCheckInExpired"] = "dd1029a0-393b-4e08-80b3-c59a43e5d38c";
    ErrorCode["MaitresInvalidEmail"] = "9b391fde-485f-43b7-a530-0dae8da12c9c";
    ErrorCode["MaitresPendingOrderTipsToBeSynced"] = "ad2bef96-8c0d-4a28-bfb7-12073be82a83";
    // Surfboard
    ErrorCode["InvalidCorporateId"] = "b9d8c278-1eb3-40bd-8582-bcdfdebe0d55";
    // Product
    ErrorCode["ProductNeedStorageInfoWhenIncludeBoxPickup"] = "f3831c24-e280-4eab-8f93-17a2bfe91e25";
    ErrorCode["ProductIsBlocked"] = "ea4143f0-544b-445e-9c9e-2f19b12705b5";
    // ICoupon
    ErrorCode["ICouponInvalidBarcode"] = "148f4103-5277-493b-a058-ce09a298bd8c";
    ErrorCode["ICouponUnknownBarcodeFormat"] = "28efa810-0828-4fe0-b980-bfe7b096954c";
    ErrorCode["ICouponUnknownServiceProvider"] = "25f1569c-e77e-4cbe-ab5b-e0df036e4737";
    ErrorCode["ICouponNoServiceProviderReferenceSpecified"] = "9c276889-6745-4757-8fa8-6fcf6c0d634b";
    ErrorCode["ICouponUnknownTradingOutletReference"] = "5339ae81-4b85-4d37-9f83-c5d466aacb04";
    ErrorCode["ICouponNoTradingOutletReferenceSpecified"] = "8e7322ec-1099-4a4e-9312-93c9614d0066";
    ErrorCode["ICouponUnknownLocationReference"] = "bbec23d2-0241-441a-9cba-81a9556775de";
    ErrorCode["ICouponNoLocationReferenceSpecified"] = "9176f751-193a-496f-b23d-41681a2709d7";
    ErrorCode["ICouponInvalidCouponsOnCheck"] = "6aef2b26-40ac-4b21-9708-8495627ebb9f";
    ErrorCode["ICouponCannotRemovePaidCoupons"] = "2c66351c-adac-4c88-805b-20ba3d5fa81f";
    ErrorCode["ICouponTenderAlreadyUsed"] = "294ba645-e5a1-47ae-a5c0-013b92efc549";
    ErrorCode["ICouponTenderAmountExceeded"] = "06e76779-3eae-4266-8ef8-a2bcd8eeb0dc";
    ErrorCode["ICouponTenderNotFound"] = "06af9160-bfa0-4fdc-827e-68c520acbb4a";
    ErrorCode["ICouponCanOnlyHaveOneIntegrationPerOutlet"] = "d4a56e58-4717-4645-8a6c-08210301f87a";
    // Penguin Lockers
    ErrorCode["PenguinLockersInvalidOrder"] = "ef48d30b-30eb-4830-b6d4-b2d868b6b381";
    // Wolt
    ErrorCode["WoltNoAvailableCourier"] = "752acbd8-8d9a-48d2-a115-2fa3abf20480";
    ErrorCode["WoltDeliveryAddressOutsideDeliveryArea"] = "74434603-5f60-43d8-88ed-4f170d4687ab";
    ErrorCode["WoltInvalidScheduledDropOffTime"] = "566b82a0-2aeb-4120-a644-c4d4e2679a7d";
    // Adyen
    ErrorCode["AdyenIntegrationNotAvailable"] = "62d76026-8414-424e-85f0-e706e731d89f";
    // Airport Lounge Addon
    ErrorCode["AirportLoungeAddonIsInActive"] = "53256bdd-e8b4-428f-9966-d2cde804c463";
    ErrorCode["AirportLoungeCardTypeCannotBeDeleted"] = "f5e307e1-a986-45d5-a311-8fded7e2956e";
    ErrorCode["AirportLoungeAddonCannotBeDeleted"] = "14ff68fa-af2e-4266-8b85-1d008024884e";
    // License
    ErrorCode["LicenseNoActiveLicenseLinked"] = "22058c7d-b77e-4d7d-b8ef-ed75f325e13b";
    ErrorCode["LicenseLinkedLicenseExpired"] = "266779d9-f2ba-4a1f-b1d9-12f4f393bbe7";
    ErrorCode["LicenseLinkedLicenseTerminated"] = "48b44f34-b790-483e-b5af-0a9bdd8d9383";
    ErrorCode["LicenseScheduledForFutureDate"] = "2c9938ee-0e68-4c6c-ae23-92d18355d3f7";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
